/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Clear_Timecodes_ConfirmInputs */

const en_shortcut_keys_clear_timecodes_confirm = /** @type {(inputs: Shortcut_Keys_Clear_Timecodes_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const fr_shortcut_keys_clear_timecodes_confirm = /** @type {(inputs: Shortcut_Keys_Clear_Timecodes_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui`)
};

const de_shortcut_keys_clear_timecodes_confirm = /** @type {(inputs: Shortcut_Keys_Clear_Timecodes_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const it_shortcut_keys_clear_timecodes_confirm = /** @type {(inputs: Shortcut_Keys_Clear_Timecodes_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SÌ`)
};

const ru_shortcut_keys_clear_timecodes_confirm = /** @type {(inputs: Shortcut_Keys_Clear_Timecodes_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да`)
};

const es_shortcut_keys_clear_timecodes_confirm = /** @type {(inputs: Shortcut_Keys_Clear_Timecodes_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí`)
};

const zh_cn2_shortcut_keys_clear_timecodes_confirm = /** @type {(inputs: Shortcut_Keys_Clear_Timecodes_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的`)
};

const ja_shortcut_keys_clear_timecodes_confirm = /** @type {(inputs: Shortcut_Keys_Clear_Timecodes_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい`)
};

const hi_shortcut_keys_clear_timecodes_confirm = /** @type {(inputs: Shortcut_Keys_Clear_Timecodes_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाँ`)
};

const pt_pt2_shortcut_keys_clear_timecodes_confirm = /** @type {(inputs: Shortcut_Keys_Clear_Timecodes_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Shortcut_Keys_Clear_Timecodes_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_clear_timecodes_confirm = /** @type {((inputs?: Shortcut_Keys_Clear_Timecodes_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Clear_Timecodes_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_clear_timecodes_confirm(inputs)
	if (locale === "de") return de_shortcut_keys_clear_timecodes_confirm(inputs)
	if (locale === "it") return it_shortcut_keys_clear_timecodes_confirm(inputs)
	if (locale === "ru") return ru_shortcut_keys_clear_timecodes_confirm(inputs)
	if (locale === "es") return es_shortcut_keys_clear_timecodes_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_clear_timecodes_confirm(inputs)
	if (locale === "ja") return ja_shortcut_keys_clear_timecodes_confirm(inputs)
	if (locale === "hi") return hi_shortcut_keys_clear_timecodes_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_clear_timecodes_confirm(inputs)
	return en_shortcut_keys_clear_timecodes_confirm(inputs)
});